// 학생관리 필드명 리스트
export const StudentAttributes = Object({
    birthDay : '생년월일',
    branchSeq : '',
    classSeq : 'Class 정보',
    createDate : '',
    currentLevel : '현재 레벨',
    eMail : '이메일',
    engName : '영문이름',
    fatherMobile : '부(父) 휴대폰',
    gender : '성별(0:남, 1:여)',
    instituteName : '학원명',
    instituteSeq : '학원 seq',
    isLunar : '0:양력, 1:음력',
    lastUpdateDate : '',
    memo1 : '메모1',
    memo2 : '메모2',
    mobilephone : '핸드폰 번호',
    motherMobile : '모(母) 휴대폰',
    name : '이름',
    password : 'password',
    photo : '사진',
    schoolEnterDate : '입학일',
    schoolGrade : '학년(0:1학년~)',
    schoolLeaveDate : '퇴교일',
    schoolName : '학교명',
    schoolType : '0:초등, 1:중등, 2:고등',
    status : '상태(0:수강중, 1:퇴교',
    studentID : '학생 ID',
    telephone : '전화번호',
    userID : 'ID',
    userType : '멤버 타입',
    zipCode : '우편번호',
    zipDetail : '주소세부',
    zipName : '주소'
})